import { render, staticRenderFns } from "./PricingBandPortal.vue?vue&type=template&id=775fca30&scoped=true&"
import script from "./PricingBandPortal.vue?vue&type=script&lang=js&"
export * from "./PricingBandPortal.vue?vue&type=script&lang=js&"
import style0 from "./PricingBandPortal.vue?vue&type=style&index=0&id=775fca30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775fca30",
  null
  
)

export default component.exports